module.exports = __webpack_public_path__ + "img/bank icon.64feb8e3.svg";